import {z} from 'zod';
import {FileExtension, ToolName} from '../copilot.enums';
import {ToolExecuteParams, ToolResult} from '../copilot.types';
import tool from '../utils/creators/tool';
import toolResult from '../utils/creators/toolResult';

const inputSchema = z.object({
  fileExtensions: z.array(z.nativeEnum(FileExtension)).nullable().optional(),
});

export default function getFilesTool() {
  async function execute({
    toolUtils,
    input: {fileExtensions},
  }: ToolExecuteParams<typeof inputSchema>): Promise<ToolResult> {
    const files = toolUtils.getFiles(fileExtensions ?? []);

    return toolResult(
      JSON.stringify(
        files.map(({id, name, extension, content}) => ({
          id,
          filename: name,
          extension,
          content,
        })),
      ),
    );
  }

  return tool({
    name: ToolName.GetFiles,
    displayName: 'Retrieving files',
    description:
      'Retrieves current conversation files with metadata: id, filename, extension, type, description, and worksheets.',
    execute,
    inputSchema,
  });
}
